import { Dialog, DialogProps } from "primereact/dialog";
import { Dispatch, ReactNode, SetStateAction } from "react";
import "../../styles/common/Modal.scss";
import "../../styles/components/Buttons.scss";

export interface ModalProps {
  visible: boolean;
  setVisible:
    | Dispatch<SetStateAction<boolean>>
    | ((condition: boolean) => void);
  onHideBeforeVisibleSetToFalse?: () => void;
  footer?: ReactNode | ((props: DialogProps) => ReactNode); // Prime React Dialog footer props
  headerText: string | ReactNode;
  icon?: string; // Example: 'pi pi-exclamation-circle'
  bodyText?: string;
  bodyContent?: ReactNode;
  className?: string;
  isClosable?: boolean;
  isDismissable?: boolean;
  bodyClassName?: string;
  bodyTextClassName?: string;
  headerClassName?: string;
  secondaryHeaderText?: string;
  primaryHeaderClassName?: string;
}

export const Modal = ({
  visible,
  setVisible,
  onHideBeforeVisibleSetToFalse,
  footer,
  headerText,
  icon,
  bodyText,
  bodyContent,
  className,
  isClosable = true,
  isDismissable = true,
  bodyClassName,
  secondaryHeaderText,
  primaryHeaderClassName,
  headerClassName = "text-center border-round-top-md pb-0",
  bodyTextClassName = "global-modal-body-text flex justify-content-center align-items-center",
}: ModalProps) => {
  const renderIcon = () => {
    return icon ? (
      <span>
        <i className={`${icon} global-modal-icon mr-3`}></i>
      </span>
    ) : null;
  };

  const headerContainer = () => {
    return (
      <>
        <div
          className={
            primaryHeaderClassName
              ? primaryHeaderClassName
              : "global-modal-header-text font-bold text-left"
          }
        >
          {headerText ?? ""}
        </div>
        {secondaryHeaderText && (
          <div className="text-left my-2 ml-0 secondary-header-text">
            {secondaryHeaderText}
          </div>
        )}
      </>
    );
  };

  return (
    <Dialog
      visible={visible}
      modal={true}
      closable={isClosable}
      resizable={false}
      position="center"
      dismissableMask={isDismissable}
      draggable={false}
      headerClassName={headerClassName}
      focusOnShow={false}
      header={() => headerContainer()}
      className={className ?? "global-modal"}
      onHide={() => {
        onHideBeforeVisibleSetToFalse?.();
        setVisible(false);
      }}
      breakpoints={{ "960px": "75vw", "641px": "100vw" }}
      footer={footer}
    >
      <div>
        {renderIcon() || bodyText ? (
          <div className={bodyTextClassName}>
            {renderIcon()}
            <span className="font-medium">{bodyText ?? ""}</span>
          </div>
        ) : (
          <></>
        )}
        {/* Dropdowns and other components */}
        <div className={bodyClassName ?? "global-modal-body-content"}>
          {bodyContent ?? null}
        </div>
      </div>
    </Dialog>
  );
};
